import requestAxios from "@/helpers/request_axios";
import * as MutationsType from "./mutationsType";
import { ordersCollection } from "@/config/firebase";
import { roles } from "@/helpers/get_constants";

export default {
  async getOrderById({ commit }, { id }) {
    const unsubscribe = await ordersCollection.doc(id).onSnapshot(async (doc) => {
      let order = { ...doc.data(), id: doc.id };
      commit(MutationsType.SET_ORDER, order);
      commit(MutationsType.UPDATE_ORDER, order);
    });
    commit(MutationsType.UNSUBSCRIBE_GET_ORDER, unsubscribe);
  },
  async getOrderAllDetail({ state }, { id }) {
    try {
      if (state.order && state.order.id === id) return state.order;

      let response = await requestAxios({
        url: `/awy/api/v1/order/${id}`,
        method: "GET",
      });
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  unsubscribeGetOrder({ commit, state }) {
    state.unsubscribeOrder();
    commit(MutationsType.SET_ORDER, null);
    commit(MutationsType.UNSUBSCRIBE_GET_ORDER, null);
  },
  async getAllOrders({ commit, rootState, state }, payload) {
    try {
      let agent = rootState.Agent.agent;
      let reference = ordersCollection;
      let referenceFirstOrder = ordersCollection;

      if ([roles.ADVISOR, roles.ADVISOR_LEVEL1, roles.ADVISOR_LEVEL2].includes(agent.role)) {
        reference = reference.where("agent_id", "==", agent.uid);
        referenceFirstOrder = referenceFirstOrder.where("agent_id", "==", agent.uid);
      }

      if ([roles.SUPERVISOR, roles.ENTREPRENEUR].includes(agent.role)) {
        reference = reference.where("team_id", "==", agent.team_id);
        referenceFirstOrder = referenceFirstOrder.where("team_id", "==", agent.team_id);
      }

      if (payload?.filters) {
        if (payload.filters["delivery_state"]) {
          reference = reference.where("delivery_state", "==", payload.filters["delivery_state"]);
          referenceFirstOrder = referenceFirstOrder.where("delivery_state", "==", payload.filters["delivery_state"]);
        }

        if (payload.filters["payment_state"]) {
          reference = reference.where("payment_state", "==", payload.filters["payment_state"]);
          referenceFirstOrder = referenceFirstOrder.where("payment_state", "==", payload.filters["payment_state"]);
        }

        if (payload.filters["products_ids"]) {
          reference = reference.where("products_ids", "array-contains", payload.filters["products_ids"]);
          referenceFirstOrder = referenceFirstOrder.where(
            "products_ids",
            "array-contains",
            payload.filters["products_ids"],
          );
        }
      }

      reference = reference.orderBy("created_at", "asc");

      const snapOrders = await referenceFirstOrder.orderBy("created_at", "desc").limit(40).get();
      if (!snapOrders.empty) reference = reference.startAt(snapOrders.docs[snapOrders.size - 1]);

      const unsubscribe = await reference.onSnapshot(async (snap) => {
        if (!state.orders) commit(MutationsType.SET_ORDERS, []);

        snap.docChanges().forEach((change) => {
          if (change.type === "added") {
            commit(MutationsType.ADD_ORDER, { ...change.doc.data(), id: change.doc.id });
          }

          if (change.type === "modified") {
            commit(MutationsType.UPDATE_ORDER, { ...change.doc.data(), id: change.doc.id });
          }

          if (change.type === "removed") commit(MutationsType.REMOVE_ORDER, { id: change.doc.id });
        });
      });

      commit(MutationsType.UNSUBSCRIBE_GET_ALL_ORDERS, unsubscribe);
    } catch (error) {
      console.error("getAllOrders: ", error);
    }
  },
  async unsubscribeGetAllOrders({ commit, state }) {
    if (state.unsubscribeAllOrders) state.unsubscribeAllOrders();
    commit(MutationsType.SET_ORDERS, null);
    commit(MutationsType.UNSUBSCRIBE_GET_ALL_ORDERS, null);
  },
  setGroupOrders({ commit }, { orders }) {
    commit(MutationsType.SET_ORDERS, orders);
  },
  async createOrder({ commit, state }, { data }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/order",
        method: "POST",
        data: data,
      });

      if (!state.orders) commit(MutationsType.SET_ORDERS, []);
      commit(MutationsType.ADD_ORDER, response.data.data);

      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async updateOrder({ commit }, { id, data }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/order/${id}`,
        method: "PATCH",
        data: data,
      });
      commit(MutationsType.UPDATE_ORDER, response.data.data);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async setOrderProducts({ commit }, { id, products, discount }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/order/${id}/products`,
        method: "PATCH",
        data: { products, discount },
      });
      commit(MutationsType.UPDATE_ORDER, { ...response.data.data });
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async setOrderPayment({ commit }, { id, data }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/order/${id}/payment`,
        method: "PATCH",
        data: data,
      });
      commit(MutationsType.UPDATE_ORDER, { ...response.data.data });
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async setOrderDelivery({ commit }, { id, data }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/order/${id}/delivery`,
        method: "PATCH",
        data: data,
      });
      commit(MutationsType.UPDATE_ORDER, { ...response.data.data });
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async setOrderAgent({ commit }, { id, data }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/order/${id}/agent`,
        method: "PATCH",
        data: data,
      });
      commit(MutationsType.UPDATE_ORDER, { ...response.data.data });
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  // eslint-disable-next-line
  async searchOrders({}, { filters, search, page, perPage = 40 }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/order/search",
        method: "POST",
        data: {
          filters,
          search,
          page,
          perPage,
        },
      });
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  // eslint-disable-next-line
  async downloadOrders({ commit }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/order/download",
        method: "GET",
        responseType: "blob",
      });
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  // eslint-disable-next-line
  async exportOrderTemplate({ commit }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/order/export-template",
        method: "GET",
        responseType: "blob",
      });
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  // eslint-disable-next-line
  async verifyOrdersToImport({ commit }, { file, schema }) {
    try {
      let formdata = new FormData();
      formdata.append("file", file);
      formdata.append("schema", JSON.stringify(schema));
      let response = await requestAxios({
        url: "/awy/api/v1/order/importer/verify",
        method: "POST",
        data: formdata,
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  // eslint-disable-next-line
  async importOrders({ commit }, { orders, products, store }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/order/importer/import",
        method: "POST",
        data: { orders, products, store },
      });
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  // eslint-disable-next-line
  async generateOrderReport({ commit }, { sortBy, period }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/order/report",
        method: "GET",
        params: { sort: sortBy, period: period },
      });
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  resetModuleOrder({ commit }) {
    commit(MutationsType.SET_ORDER, null);
    commit(MutationsType.SET_ORDERS, null);
  },
  loadCartIGV({ commit }) {
    let igv = localStorage.getItem("cart_igv");
    igv = igv !== null ? Number(igv) : 18;
    commit(MutationsType.SET_CART_IGV, igv);
    return igv;
  },
  saveCartIGV({ commit }, { igv }) {
    localStorage.setItem("cart_igv", igv);
    commit(MutationsType.SET_CART_IGV, igv);
  },
  addCartProduct({ commit }, { product }) {
    commit(MutationsType.ADD_CART_PRODUCT, product);
  },
  removeCartProduct({ commit }, { productInd }) {
    commit(MutationsType.REMOVE_CART_PRODUCT, productInd);
  },
  resetCart({ commit }) {
    commit(MutationsType.SET_CART, []);
  },
  // eslint-disable-next-line
  async getOrderPeriodicMessages({}, { id }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/order/${id}/periodic-messages`,
        method: "GET",
      });

      return response.data.data;
    } catch (error) {
      throw error.response.data;
    }
  },
};
